export default __webpack_public_path__ + "static/media/i069vp.358a5cb1.webp";